const PaymentTypeSelector = ({ mode, cardText, voucherText, selectedType, onChange, disabled }) => {
  return (
    <div className="payment-type-selector">
      <p>{mode} :</p>
      <div style={{display: 'flex', gap: "5px"}}>
        <label 
          className={`payment-option ${selectedType === 'card' ? 'active' : ''}`} 
          style={{ cursor: disabled ? 'default' : 'pointer' }}
        >
          <input
            type="radio"
            name="paymentType"
            value="card"
            checked={selectedType === 'card'}
            onChange={() => onChange('card')}
            disabled={disabled}
          />
          {cardText}
        </label>

        <label 
          className={`payment-option ${selectedType === 'voucher' ? 'active' : ''}`} 
          style={{ cursor: disabled ? 'default' : 'pointer' }}
        >
          <input
            type="radio"
            name="paymentType"
            value="voucher"
            checked={selectedType === 'voucher'}
            onChange={() => onChange('voucher')}
            disabled={disabled}
          />
          {voucherText}
        </label>
      </div>
    </div>
  );
};

export default PaymentTypeSelector;